webpackJsonp([23899280101116],{

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(64);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkPreviewCard = function (_React$Component) {
		_inherits(WorkPreviewCard, _React$Component);
	
		function WorkPreviewCard() {
			_classCallCheck(this, WorkPreviewCard);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		WorkPreviewCard.prototype.render = function render() {
			var _props$portfolio$node = this.props.portfolio.node,
			    title = _props$portfolio$node.title,
			    featured_media = _props$portfolio$node.featured_media,
			    acf = _props$portfolio$node.acf,
			    slug = _props$portfolio$node.slug;
	
			console.log(acf, 'acf');
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'a',
					{
						target: acf.site_url !== '' ? '_blank' : '',
						href: acf.site_url !== '' ? acf.site_url : ''
					},
					_react2.default.createElement(
						'div',
						{ className: 'lightbox-wrap' },
						_react2.default.createElement(
							'div',
							{ className: 'lightbox' },
							_react2.default.createElement(
								'div',
								{ className: 'lightbox-header' },
								_react2.default.createElement(_gatsbyImage2.default, {
									sizes: featured_media.localFile.childImageSharp.sizes,
									style: {
										maxHeight: '300px',
										height: '300px',
										overflow: 'hidden'
									},
									imgStyle: {
										maxHeight: '300px',
										height: '300px',
										overflow: 'hidden'
									}
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'lightbox-body' },
								_react2.default.createElement(
									'div',
									{ className: 'title' },
									_react2.default.createElement(
										'h3',
										null,
										title
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'links' },
									_react2.default.createElement(
										'ul',
										null,
										(acf.site_url !== '' || null) && _react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												'a',
												null,
												'Visit'
											)
										),
										acf.case_study && acf.case_study !== 'none' && _react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_gatsbyLink2.default,
												{ to: slug },
												'View Case Study'
											)
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		return WorkPreviewCard;
	}(_react2.default.Component);
	
	exports.default = WorkPreviewCard;
	module.exports = exports['default'];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\tbackground: #fff;\n\tpadding: 0px 0px;\n\t.title-wrap {\n\t\tpadding: 0px 40px;\n\t\ttext-align: center;\n\t\th2 {\n\t\t\tcolor: #000;\n\t\t\tfont-family: \'Open Sans\', sans-serif;\n\t\t\tmargin-top: 0px;\n\t\t\tmargin-bottom: 40px;\n\t\t\tfont-weight: 300;\n\t\t}\n\t}\n\n\t.work-preview-grid {\n\t\tdisplay: grid;\n\t\tgrid-gap: 40px;\n\t\tmax-width: 95vw;\n\t\tmargin: 0 auto;\n\t\tpadding: 40px 0px;\n\n\t\t', ';\n\t\t', ';\n\t}\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: #222;\n\n\t\t&:hover {\n\t\t\t.lightbox-wrap {\n\t\t\t\t-webkit-box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),\n\t\t\t\t\t0 9px 46px 8px rgba(0, 0, 0, 0.12),\n\t\t\t\t\t0 11px 15px -7px rgba(0, 0, 0, 0.2);\n\t\t\t\tbox-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),\n\t\t\t\t\t0 9px 46px 8px rgba(0, 0, 0, 0.12),\n\t\t\t\t\t0 11px 15px -7px rgba(0, 0, 0, 0.2);\n\t\t\t}\n\n\t\t\t.links {\n\t\t\t\ta {\n\t\t\t\t\tbackground: #333;\n\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.lightbox-wrap {\n\t\t\tborder: 1px solid #d8d3d3;\n\t\t\t', ';\n\n\t\t\t.lightbox-body {\n\t\t\t\tbackground: #fff;\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 50% 50%;\n\t\t\t\tpadding: 20px;\n\n\t\t\t\th3 {\n\t\t\t\t\tfont-family: \'Open Sans\', sans-serif;\n\t\t\t\t\tmargin: 0px;\n\n\t\t\t\t\tfont-weight: 300;\n\t\t\t\t}\n\n\t\t\t\t.links {\n\t\t\t\t\talign-self: center;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t\tul {\n\t\t\t\t\t\tmargin: 0px;\n\t\t\t\t\t\tpadding: 0px;\n\t\t\t\t\t\tlist-style: none;\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\tcolor: #333;\n\t\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t\t\tborder: 1px solid #333;\n\t\t\t\t\t\t\t\tpadding: 5px 20px;\n\t\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\t\t\t', ';\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tbackground: #333;\n\t\t\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n'], ['\n\tbackground: #fff;\n\tpadding: 0px 0px;\n\t.title-wrap {\n\t\tpadding: 0px 40px;\n\t\ttext-align: center;\n\t\th2 {\n\t\t\tcolor: #000;\n\t\t\tfont-family: \'Open Sans\', sans-serif;\n\t\t\tmargin-top: 0px;\n\t\t\tmargin-bottom: 40px;\n\t\t\tfont-weight: 300;\n\t\t}\n\t}\n\n\t.work-preview-grid {\n\t\tdisplay: grid;\n\t\tgrid-gap: 40px;\n\t\tmax-width: 95vw;\n\t\tmargin: 0 auto;\n\t\tpadding: 40px 0px;\n\n\t\t', ';\n\t\t', ';\n\t}\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: #222;\n\n\t\t&:hover {\n\t\t\t.lightbox-wrap {\n\t\t\t\t-webkit-box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),\n\t\t\t\t\t0 9px 46px 8px rgba(0, 0, 0, 0.12),\n\t\t\t\t\t0 11px 15px -7px rgba(0, 0, 0, 0.2);\n\t\t\t\tbox-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),\n\t\t\t\t\t0 9px 46px 8px rgba(0, 0, 0, 0.12),\n\t\t\t\t\t0 11px 15px -7px rgba(0, 0, 0, 0.2);\n\t\t\t}\n\n\t\t\t.links {\n\t\t\t\ta {\n\t\t\t\t\tbackground: #333;\n\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.lightbox-wrap {\n\t\t\tborder: 1px solid #d8d3d3;\n\t\t\t', ';\n\n\t\t\t.lightbox-body {\n\t\t\t\tbackground: #fff;\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 50% 50%;\n\t\t\t\tpadding: 20px;\n\n\t\t\t\th3 {\n\t\t\t\t\tfont-family: \'Open Sans\', sans-serif;\n\t\t\t\t\tmargin: 0px;\n\n\t\t\t\t\tfont-weight: 300;\n\t\t\t\t}\n\n\t\t\t\t.links {\n\t\t\t\t\talign-self: center;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t\tul {\n\t\t\t\t\t\tmargin: 0px;\n\t\t\t\t\t\tpadding: 0px;\n\t\t\t\t\t\tlist-style: none;\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\tcolor: #333;\n\t\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t\t\tborder: 1px solid #333;\n\t\t\t\t\t\t\t\tpadding: 5px 20px;\n\t\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\t\t\t', ';\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tbackground: #333;\n\t\t\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['grid-template-columns: repeat(2, 1fr);'], ['grid-template-columns: repeat(2, 1fr);']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['grid-template-columns: repeat(3, 1fr);'], ['grid-template-columns: repeat(3, 1fr);']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Cards = __webpack_require__(231);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _Banners = __webpack_require__(71);
	
	var _helpers = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var WorkSection = _styledComponents2.default.section(_templateObject, _helpers.media.small(_templateObject2), _helpers.media.large(_templateObject3), (0, _helpers.TransitionMixin)('.25s'), (0, _helpers.TransitionMixin)('.25s'));
	
	var WorkPage = function (_React$Component) {
		_inherits(WorkPage, _React$Component);
	
		function WorkPage() {
			_classCallCheck(this, WorkPage);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		WorkPage.prototype.render = function render() {
			var data = this.props.data;
	
			return _react2.default.createElement(
				WorkSection,
				null,
				_react2.default.createElement(_Banners.HalfBanner, { title: 'Our Work', image: data.topBanner, mobile: true }),
				_react2.default.createElement(
					'div',
					{ className: 'work-preview-grid' },
					data.allWordpressWpPortfolio.edges.map(function (portfolio) {
						return _react2.default.createElement(_Cards2.default, { key: portfolio.id, portfolio: portfolio });
					})
				)
			);
		};
	
		return WorkPage;
	}(_react2.default.Component);
	
	exports.default = WorkPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-js-2ef070131d578c161fe6.js